import { ApplicationState } from '.';

export const getStudent = (state: ApplicationState) => state.student;
export const getAuth = (state: ApplicationState) => state.auth;
export const getData = (state: ApplicationState) => state.data;
export const getUI = (state: ApplicationState) => state.ui;
export const getConfig = (state: ApplicationState) => state.config;
export const getUniCode = (state: ApplicationState) => state.config.universityCode;
export const getUniName = (state: ApplicationState) => state.config.universityName;
export const getOfferOrIntakeMode = (state: ApplicationState) => {
  return state.config.multiOfferStudentFlow ? 'Offer' : 'Intake';
};
export const getWebsocket = (state: ApplicationState) => state.websocket;
